<template>
  <el-row type="flex" justify="space-between" class="element-name-row">
    <click-to-edit
      v-model="scope.row.name"
      class="element-name-edit"
      :placeholder="$companyConfiguration.i18n.t('card', 'section_element_name_column_placeholder')"
      :disabled="!isFieldAvailableForEdit(scope.row, 'name')"
      type="textarea"
      :word-limit="$companyConfiguration.settings.getElementsNameMaxLength()===false ? 0 :$companyConfiguration.settings.getElementsNameMaxLength()"
      :show-word-limit="!!$companyConfiguration.settings.getElementsNameMaxLength()"
      show-word-limit
      @input="saveElementPropChange(scope.row, 'name')"
    ></click-to-edit>
    <click-to-edit
      v-model="scope.row.desc"
      :placeholder="isFieldAvailableForEdit(scope.row, 'desc')
                      ? $companyConfiguration.i18n.t('card', 'section_element_desc_column_placeholder')
                      : 'Описание не добавлено'"
      :disabled="!isFieldAvailableForEdit(scope.row, 'desc')"
      type="button-modal"
      modal-title="Описание"
      @input="saveElementPropChange(scope.row, 'desc')"
    >
      <el-button
        slot="reference"
        class="table-action-button open-desc-button"
        :class="{'has-desc': !!scope.row.desc}"
        type="text"
        round
        size="mini"
        icon="fas fa-info-circle"
      ></el-button>
    </click-to-edit>
  </el-row>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
export default {
  name: 'element-name-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],

  props: {},
  data() {
    return {

    }
  },
  computed: {},
  methods: {

  }
}

</script>

<style scoped lang="scss">
@import "./src/assets/css/project-variables";

.element-name-row {
  width: 100%;
  flex-wrap: nowrap;
  align-items: flex-start;
}

.element-name-edit {
  flex: 1 1 auto;
  min-width: 0;
  width: auto;

  ::v-deep .click-to-edit-div {
    width: 100%;
    box-sizing: border-box;
  }
  ::v-deep .el-textarea,
  ::v-deep .el-input {
    width: 100%;
  }
}

.open-desc-button {
  color: gray;

  &.has-desc{
    color: $--color-primary;
  }
}

</style>
